let wakeLockSentinel = null;
let shouldStayAwake = false;

const canUseWakeLock = () => typeof navigator !== "undefined" && "wakeLock" in navigator;

const requestWakeLock = async () => {
  shouldStayAwake = true;
  if (!canUseWakeLock()) return false;

  try {
    wakeLockSentinel = await navigator.wakeLock.request("screen");
    wakeLockSentinel.addEventListener("release", () => {
      wakeLockSentinel = null;
    });
    return true;
  } catch (err) {
    return false;
  }
};

const releaseWakeLock = async () => {
  shouldStayAwake = false;
  if (!wakeLockSentinel) return;
  try {
    await wakeLockSentinel.release();
  } catch (err) {
    // no-op
  } finally {
    wakeLockSentinel = null;
  }
};

const bindWakeLockAutoReacquire = () => {
  const onVisibilityChange = async () => {
    if (shouldStayAwake && document.visibilityState === "visible" && !wakeLockSentinel) {
      await requestWakeLock();
    }
  };

  document.addEventListener("visibilitychange", onVisibilityChange);
  return () => document.removeEventListener("visibilitychange", onVisibilityChange);
};

export {requestWakeLock, releaseWakeLock, bindWakeLockAutoReacquire};
